const HowToEarnDrawTicketsBadge = () => {
  return (
    <>
      <div className={"p-2 bg-gray-6 rounded-lg flex items-center gap-3 font-jost"}>
        <div className={"rounded-full size-6 min-w-6 flex-center bg-gray-5"}>
          <span className={"italic text-white text-[9px] font-[900] text-center"}>TIP!</span>
        </div>
        <div className={"text-gray-1 text-xs lg:text-sm font-normal leading-4 lg:leading-5"}>
          Look out for Featured Competitions (like Dream Car) to maximise your ticket count for every pound you spend
        </div>
      </div>
    </>
  );
};

export default HowToEarnDrawTicketsBadge;
